/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicResetSuccessRouteImport } from './routes/_public/reset-success'
import { Route as AuthenticatedStoriesRouteImport } from './routes/_authenticated/stories'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedLibraryRouteImport } from './routes/_authenticated/library'
import { Route as AuthenticatedFeedRouteImport } from './routes/_authenticated/feed'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAiRouteImport } from './routes/_authenticated/ai'
import { Route as AuthenticatedWebsiteIndexRouteImport } from './routes/_authenticated/website/index'
import { Route as AuthenticatedWebLinksIndexRouteImport } from './routes/_authenticated/web-links/index'
import { Route as AuthenticatedSurveysIndexRouteImport } from './routes/_authenticated/surveys/index'
import { Route as AuthenticatedSuperAdminIndexRouteImport } from './routes/_authenticated/super-admin/index'
import { Route as AuthenticatedResidentsIndexRouteImport } from './routes/_authenticated/residents/index'
import { Route as AuthenticatedPostsIndexRouteImport } from './routes/_authenticated/posts/index'
import { Route as AuthenticatedPlacesIndexRouteImport } from './routes/_authenticated/places/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedMeetingsIndexRouteImport } from './routes/_authenticated/meetings/index'
import { Route as AuthenticatedMediaIndexRouteImport } from './routes/_authenticated/media/index'
import { Route as AuthenticatedIncidentsIndexRouteImport } from './routes/_authenticated/incidents/index'
import { Route as AuthenticatedHomeIndexRouteImport } from './routes/_authenticated/home/index'
import { Route as AuthenticatedConversationsIndexRouteImport } from './routes/_authenticated/conversations/index'
import { Route as AuthenticatedCalendarsIndexRouteImport } from './routes/_authenticated/calendars/index'
import { Route as AuthenticatedCalendarIndexRouteImport } from './routes/_authenticated/calendar/index'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/app/index'
import { Route as PublicPPostIdRouteImport } from './routes/_public/p/$postId'
import { Route as AuthenticatedWebLinksNewRouteImport } from './routes/_authenticated/web-links/new'
import { Route as AuthenticatedWebLinksWebLinkIdRouteImport } from './routes/_authenticated/web-links/$webLinkId'
import { Route as AuthenticatedSurveysNewRouteImport } from './routes/_authenticated/surveys/new'
import { Route as AuthenticatedSettingsUsersRouteImport } from './routes/_authenticated/settings/users'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsOrganizationsRouteImport } from './routes/_authenticated/settings/organizations'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsInfoRouteImport } from './routes/_authenticated/settings/info'
import { Route as AuthenticatedSettingsFacebookSuccessRouteImport } from './routes/_authenticated/settings/facebook-success'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsConnectionsRouteImport } from './routes/_authenticated/settings/connections'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedResidentsNewRouteImport } from './routes/_authenticated/residents/new'
import { Route as AuthenticatedResidentsMapRouteImport } from './routes/_authenticated/residents/map'
import { Route as AuthenticatedResidentsIdRouteImport } from './routes/_authenticated/residents/$id'
import { Route as AuthenticatedProfilesNewRouteImport } from './routes/_authenticated/profiles/new'
import { Route as AuthenticatedPostsTipyTapRouteImport } from './routes/_authenticated/posts/tipy-tap'
import { Route as AuthenticatedPostsNewTipTapRouteImport } from './routes/_authenticated/posts/new-tip-tap'
import { Route as AuthenticatedPostsNewPageRouteImport } from './routes/_authenticated/posts/new-page'
import { Route as AuthenticatedPostsNewRouteImport } from './routes/_authenticated/posts/new'
import { Route as AuthenticatedPostsPostIdRouteImport } from './routes/_authenticated/posts/$postId'
import { Route as AuthenticatedPlacesNewRouteImport } from './routes/_authenticated/places/new'
import { Route as AuthenticatedPlacesPlaceIdRouteImport } from './routes/_authenticated/places/$placeId'
import { Route as AuthenticatedNotificationsNewRouteImport } from './routes/_authenticated/notifications/new'
import { Route as AuthenticatedMeetingsNewRouteImport } from './routes/_authenticated/meetings/new'
import { Route as AuthenticatedMeetingsMeetingIdRouteImport } from './routes/_authenticated/meetings/$meetingId'
import { Route as AuthenticatedMediaNewRouteImport } from './routes/_authenticated/media/new'
import { Route as AuthenticatedMediaGridRouteImport } from './routes/_authenticated/media/grid'
import { Route as AuthenticatedMediaMediaIdRouteImport } from './routes/_authenticated/media/$mediaId'
import { Route as AuthenticatedLinksTranslationsRouteImport } from './routes/_authenticated/links/translations'
import { Route as AuthenticatedIncidentsIncidentIdRouteImport } from './routes/_authenticated/incidents/$incidentId'
import { Route as AuthenticatedConversationsNewRouteImport } from './routes/_authenticated/conversations/new'
import { Route as AuthenticatedConversationsConversationIdRouteImport } from './routes/_authenticated/conversations/$conversationId'
import { Route as AuthenticatedAppStoriesRouteImport } from './routes/_authenticated/app/stories'
import { Route as AuthenticatedAppQuickAccessRouteImport } from './routes/_authenticated/app/quick-access'
import { Route as AuthenticatedAppPostsRouteImport } from './routes/_authenticated/app/posts'
import { Route as AuthenticatedAppPinnedPostsRouteImport } from './routes/_authenticated/app/pinned-posts'
import { Route as AuthenticatedAppFeedRouteImport } from './routes/_authenticated/app/feed'
import { Route as AuthenticatedWebsiteStaffDirectoryIndexRouteImport } from './routes/_authenticated/website/staff-directory/index'
import { Route as AuthenticatedWebsiteNoticesIndexRouteImport } from './routes/_authenticated/website/notices/index'
import { Route as AuthenticatedWebsiteNewsNoticesIndexRouteImport } from './routes/_authenticated/website/news-notices/index'
import { Route as AuthenticatedWebsiteJobsIndexRouteImport } from './routes/_authenticated/website/jobs/index'
import { Route as AuthenticatedWebsiteGovernmentDocumentsIndexRouteImport } from './routes/_authenticated/website/government-documents/index'
import { Route as AuthenticatedWebsiteEventsIndexRouteImport } from './routes/_authenticated/website/events/index'
import { Route as AuthenticatedWebsiteDownloadsIndexRouteImport } from './routes/_authenticated/website/downloads/index'
import { Route as AuthenticatedWebsiteDocumentsIndexRouteImport } from './routes/_authenticated/website/documents/index'
import { Route as AuthenticatedWebsiteDisclosuresIndexRouteImport } from './routes/_authenticated/website/disclosures/index'
import { Route as AuthenticatedSuperAdminOrganizationsIndexRouteImport } from './routes/_authenticated/super-admin/organizations/index'
import { Route as AuthenticatedCalendarCalendarIdIndexRouteImport } from './routes/_authenticated/calendar/$calendarId/index'
import { Route as AuthenticatedAppQuickAccessIndexRouteImport } from './routes/_authenticated/app/quick-access/index'
import { Route as AuthenticatedAppHomeIndexRouteImport } from './routes/_authenticated/app/home/index'
import { Route as AuthenticatedAppFeedIndexRouteImport } from './routes/_authenticated/app/feed/index'
import { Route as AuthenticatedSuperAdminOrganizationsNewRouteImport } from './routes/_authenticated/super-admin/organizations/new'
import { Route as AuthenticatedSuperAdminOrganizationsListRouteImport } from './routes/_authenticated/super-admin/organizations/list'
import { Route as AuthenticatedAppQuickAccessNewRouteImport } from './routes/_authenticated/app/quick-access/new'
import { Route as AuthenticatedCalendarCalendarIdEventsIndexRouteImport } from './routes/_authenticated/calendar/$calendarId/events/index'
import { Route as AuthenticatedAppQuickAccessSectionsIndexRouteImport } from './routes/_authenticated/app/quick-access/sections/index'
import { Route as AuthenticatedAppFeedCategoriesIndexRouteImport } from './routes/_authenticated/app/feed/categories/index'
import { Route as AuthenticatedSuperAdminOrganizationsOrganizationIdEditRouteImport } from './routes/_authenticated/super-admin/organizations/$organizationId/edit'
import { Route as AuthenticatedCalendarCalendarIdEventsNewRouteImport } from './routes/_authenticated/calendar/$calendarId/events/new'
import { Route as AuthenticatedCalendarCalendarIdEventsEventIdRouteImport } from './routes/_authenticated/calendar/$calendarId/events/$eventId'
import { Route as AuthenticatedAppQuickAccessSectionsNewRouteImport } from './routes/_authenticated/app/quick-access/sections/new'
import { Route as AuthenticatedAppQuickAccessSectionsSectionIdRouteImport } from './routes/_authenticated/app/quick-access/sections/$sectionId'
import { Route as AuthenticatedAppFeedCategoriesNewRouteImport } from './routes/_authenticated/app/feed/categories/new'
import { Route as AuthenticatedAppFeedCategoriesCategoryIdRouteImport } from './routes/_authenticated/app/feed/categories/$categoryId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicResetSuccessRoute = PublicResetSuccessRouteImport.update({
  id: '/reset-success',
  path: '/reset-success',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedStoriesRoute = AuthenticatedStoriesRouteImport.update({
  id: '/stories',
  path: '/stories',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLibraryRoute = AuthenticatedLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFeedRoute = AuthenticatedFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAiRoute = AuthenticatedAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWebsiteIndexRoute =
  AuthenticatedWebsiteIndexRouteImport.update({
    id: '/website/',
    path: '/website/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebLinksIndexRoute =
  AuthenticatedWebLinksIndexRouteImport.update({
    id: '/web-links/',
    path: '/web-links/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSurveysIndexRoute =
  AuthenticatedSurveysIndexRouteImport.update({
    id: '/surveys/',
    path: '/surveys/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuperAdminIndexRoute =
  AuthenticatedSuperAdminIndexRouteImport.update({
    id: '/super-admin/',
    path: '/super-admin/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedResidentsIndexRoute =
  AuthenticatedResidentsIndexRouteImport.update({
    id: '/residents/',
    path: '/residents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPostsIndexRoute = AuthenticatedPostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlacesIndexRoute =
  AuthenticatedPlacesIndexRouteImport.update({
    id: '/places/',
    path: '/places/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMeetingsIndexRoute =
  AuthenticatedMeetingsIndexRouteImport.update({
    id: '/meetings/',
    path: '/meetings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMediaIndexRoute = AuthenticatedMediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedIncidentsIndexRoute =
  AuthenticatedIncidentsIndexRouteImport.update({
    id: '/incidents/',
    path: '/incidents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeIndexRoute = AuthenticatedHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConversationsIndexRoute =
  AuthenticatedConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarsIndexRoute =
  AuthenticatedCalendarsIndexRouteImport.update({
    id: '/calendars/',
    path: '/calendars/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarIndexRoute =
  AuthenticatedCalendarIndexRouteImport.update({
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicPPostIdRoute = PublicPPostIdRouteImport.update({
  id: '/p/$postId',
  path: '/p/$postId',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedWebLinksNewRoute =
  AuthenticatedWebLinksNewRouteImport.update({
    id: '/web-links/new',
    path: '/web-links/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebLinksWebLinkIdRoute =
  AuthenticatedWebLinksWebLinkIdRouteImport.update({
    id: '/web-links/$webLinkId',
    path: '/web-links/$webLinkId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSurveysNewRoute = AuthenticatedSurveysNewRouteImport.update({
  id: '/surveys/new',
  path: '/surveys/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsUsersRoute =
  AuthenticatedSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsOrganizationsRoute =
  AuthenticatedSettingsOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsInfoRoute =
  AuthenticatedSettingsInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsFacebookSuccessRoute =
  AuthenticatedSettingsFacebookSuccessRouteImport.update({
    id: '/facebook-success',
    path: '/facebook-success',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsConnectionsRoute =
  AuthenticatedSettingsConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedResidentsNewRoute =
  AuthenticatedResidentsNewRouteImport.update({
    id: '/residents/new',
    path: '/residents/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedResidentsMapRoute =
  AuthenticatedResidentsMapRouteImport.update({
    id: '/residents/map',
    path: '/residents/map',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedResidentsIdRoute =
  AuthenticatedResidentsIdRouteImport.update({
    id: '/residents/$id',
    path: '/residents/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfilesNewRoute =
  AuthenticatedProfilesNewRouteImport.update({
    id: '/profiles/new',
    path: '/profiles/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPostsTipyTapRoute =
  AuthenticatedPostsTipyTapRouteImport.update({
    id: '/posts/tipy-tap',
    path: '/posts/tipy-tap',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPostsNewTipTapRoute =
  AuthenticatedPostsNewTipTapRouteImport.update({
    id: '/posts/new-tip-tap',
    path: '/posts/new-tip-tap',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPostsNewPageRoute =
  AuthenticatedPostsNewPageRouteImport.update({
    id: '/posts/new-page',
    path: '/posts/new-page',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPostsNewRoute = AuthenticatedPostsNewRouteImport.update({
  id: '/posts/new',
  path: '/posts/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPostsPostIdRoute =
  AuthenticatedPostsPostIdRouteImport.update({
    id: '/posts/$postId',
    path: '/posts/$postId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlacesNewRoute = AuthenticatedPlacesNewRouteImport.update({
  id: '/places/new',
  path: '/places/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlacesPlaceIdRoute =
  AuthenticatedPlacesPlaceIdRouteImport.update({
    id: '/places/$placeId',
    path: '/places/$placeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsNewRoute =
  AuthenticatedNotificationsNewRouteImport.update({
    id: '/notifications/new',
    path: '/notifications/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMeetingsNewRoute =
  AuthenticatedMeetingsNewRouteImport.update({
    id: '/meetings/new',
    path: '/meetings/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMeetingsMeetingIdRoute =
  AuthenticatedMeetingsMeetingIdRouteImport.update({
    id: '/meetings/$meetingId',
    path: '/meetings/$meetingId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMediaNewRoute = AuthenticatedMediaNewRouteImport.update({
  id: '/media/new',
  path: '/media/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMediaGridRoute = AuthenticatedMediaGridRouteImport.update({
  id: '/media/grid',
  path: '/media/grid',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMediaMediaIdRoute =
  AuthenticatedMediaMediaIdRouteImport.update({
    id: '/media/$mediaId',
    path: '/media/$mediaId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLinksTranslationsRoute =
  AuthenticatedLinksTranslationsRouteImport.update({
    id: '/links/translations',
    path: '/links/translations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsIncidentIdRoute =
  AuthenticatedIncidentsIncidentIdRouteImport.update({
    id: '/incidents/$incidentId',
    path: '/incidents/$incidentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConversationsNewRoute =
  AuthenticatedConversationsNewRouteImport.update({
    id: '/conversations/new',
    path: '/conversations/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConversationsConversationIdRoute =
  AuthenticatedConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppStoriesRoute = AuthenticatedAppStoriesRouteImport.update({
  id: '/app/stories',
  path: '/app/stories',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppQuickAccessRoute =
  AuthenticatedAppQuickAccessRouteImport.update({
    id: '/app/quick-access',
    path: '/app/quick-access',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppPostsRoute = AuthenticatedAppPostsRouteImport.update({
  id: '/app/posts',
  path: '/app/posts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppPinnedPostsRoute =
  AuthenticatedAppPinnedPostsRouteImport.update({
    id: '/app/pinned-posts',
    path: '/app/pinned-posts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppFeedRoute = AuthenticatedAppFeedRouteImport.update({
  id: '/app/feed',
  path: '/app/feed',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWebsiteStaffDirectoryIndexRoute =
  AuthenticatedWebsiteStaffDirectoryIndexRouteImport.update({
    id: '/website/staff-directory/',
    path: '/website/staff-directory/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteNoticesIndexRoute =
  AuthenticatedWebsiteNoticesIndexRouteImport.update({
    id: '/website/notices/',
    path: '/website/notices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteNewsNoticesIndexRoute =
  AuthenticatedWebsiteNewsNoticesIndexRouteImport.update({
    id: '/website/news-notices/',
    path: '/website/news-notices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteJobsIndexRoute =
  AuthenticatedWebsiteJobsIndexRouteImport.update({
    id: '/website/jobs/',
    path: '/website/jobs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteGovernmentDocumentsIndexRoute =
  AuthenticatedWebsiteGovernmentDocumentsIndexRouteImport.update({
    id: '/website/government-documents/',
    path: '/website/government-documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteEventsIndexRoute =
  AuthenticatedWebsiteEventsIndexRouteImport.update({
    id: '/website/events/',
    path: '/website/events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteDownloadsIndexRoute =
  AuthenticatedWebsiteDownloadsIndexRouteImport.update({
    id: '/website/downloads/',
    path: '/website/downloads/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteDocumentsIndexRoute =
  AuthenticatedWebsiteDocumentsIndexRouteImport.update({
    id: '/website/documents/',
    path: '/website/documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteDisclosuresIndexRoute =
  AuthenticatedWebsiteDisclosuresIndexRouteImport.update({
    id: '/website/disclosures/',
    path: '/website/disclosures/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuperAdminOrganizationsIndexRoute =
  AuthenticatedSuperAdminOrganizationsIndexRouteImport.update({
    id: '/super-admin/organizations/',
    path: '/super-admin/organizations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarCalendarIdIndexRoute =
  AuthenticatedCalendarCalendarIdIndexRouteImport.update({
    id: '/calendar/$calendarId/',
    path: '/calendar/$calendarId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppQuickAccessIndexRoute =
  AuthenticatedAppQuickAccessIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppQuickAccessRoute,
  } as any)
const AuthenticatedAppHomeIndexRoute =
  AuthenticatedAppHomeIndexRouteImport.update({
    id: '/app/home/',
    path: '/app/home/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppFeedIndexRoute =
  AuthenticatedAppFeedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppFeedRoute,
  } as any)
const AuthenticatedSuperAdminOrganizationsNewRoute =
  AuthenticatedSuperAdminOrganizationsNewRouteImport.update({
    id: '/super-admin/organizations/new',
    path: '/super-admin/organizations/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuperAdminOrganizationsListRoute =
  AuthenticatedSuperAdminOrganizationsListRouteImport.update({
    id: '/super-admin/organizations/list',
    path: '/super-admin/organizations/list',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppQuickAccessNewRoute =
  AuthenticatedAppQuickAccessNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAppQuickAccessRoute,
  } as any)
const AuthenticatedCalendarCalendarIdEventsIndexRoute =
  AuthenticatedCalendarCalendarIdEventsIndexRouteImport.update({
    id: '/calendar/$calendarId/events/',
    path: '/calendar/$calendarId/events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppQuickAccessSectionsIndexRoute =
  AuthenticatedAppQuickAccessSectionsIndexRouteImport.update({
    id: '/sections/',
    path: '/sections/',
    getParentRoute: () => AuthenticatedAppQuickAccessRoute,
  } as any)
const AuthenticatedAppFeedCategoriesIndexRoute =
  AuthenticatedAppFeedCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => AuthenticatedAppFeedRoute,
  } as any)
const AuthenticatedSuperAdminOrganizationsOrganizationIdEditRoute =
  AuthenticatedSuperAdminOrganizationsOrganizationIdEditRouteImport.update({
    id: '/super-admin/organizations/$organizationId/edit',
    path: '/super-admin/organizations/$organizationId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarCalendarIdEventsNewRoute =
  AuthenticatedCalendarCalendarIdEventsNewRouteImport.update({
    id: '/calendar/$calendarId/events/new',
    path: '/calendar/$calendarId/events/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarCalendarIdEventsEventIdRoute =
  AuthenticatedCalendarCalendarIdEventsEventIdRouteImport.update({
    id: '/calendar/$calendarId/events/$eventId',
    path: '/calendar/$calendarId/events/$eventId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppQuickAccessSectionsNewRoute =
  AuthenticatedAppQuickAccessSectionsNewRouteImport.update({
    id: '/sections/new',
    path: '/sections/new',
    getParentRoute: () => AuthenticatedAppQuickAccessRoute,
  } as any)
const AuthenticatedAppQuickAccessSectionsSectionIdRoute =
  AuthenticatedAppQuickAccessSectionsSectionIdRouteImport.update({
    id: '/sections/$sectionId',
    path: '/sections/$sectionId',
    getParentRoute: () => AuthenticatedAppQuickAccessRoute,
  } as any)
const AuthenticatedAppFeedCategoriesNewRoute =
  AuthenticatedAppFeedCategoriesNewRouteImport.update({
    id: '/categories/new',
    path: '/categories/new',
    getParentRoute: () => AuthenticatedAppFeedRoute,
  } as any)
const AuthenticatedAppFeedCategoriesCategoryIdRoute =
  AuthenticatedAppFeedCategoriesCategoryIdRouteImport.update({
    id: '/categories/$categoryId',
    path: '/categories/$categoryId',
    getParentRoute: () => AuthenticatedAppFeedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/ai': typeof AuthenticatedAiRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/feed': typeof AuthenticatedFeedRoute
  '/library': typeof AuthenticatedLibraryRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/stories': typeof AuthenticatedStoriesRoute
  '/reset-success': typeof PublicResetSuccessRoute
  '/app/feed': typeof AuthenticatedAppFeedRouteWithChildren
  '/app/pinned-posts': typeof AuthenticatedAppPinnedPostsRoute
  '/app/posts': typeof AuthenticatedAppPostsRoute
  '/app/quick-access': typeof AuthenticatedAppQuickAccessRouteWithChildren
  '/app/stories': typeof AuthenticatedAppStoriesRoute
  '/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/conversations/new': typeof AuthenticatedConversationsNewRoute
  '/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/links/translations': typeof AuthenticatedLinksTranslationsRoute
  '/media/$mediaId': typeof AuthenticatedMediaMediaIdRoute
  '/media/grid': typeof AuthenticatedMediaGridRoute
  '/media/new': typeof AuthenticatedMediaNewRoute
  '/meetings/$meetingId': typeof AuthenticatedMeetingsMeetingIdRoute
  '/meetings/new': typeof AuthenticatedMeetingsNewRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/places/$placeId': typeof AuthenticatedPlacesPlaceIdRoute
  '/places/new': typeof AuthenticatedPlacesNewRoute
  '/posts/$postId': typeof AuthenticatedPostsPostIdRoute
  '/posts/new': typeof AuthenticatedPostsNewRoute
  '/posts/new-page': typeof AuthenticatedPostsNewPageRoute
  '/posts/new-tip-tap': typeof AuthenticatedPostsNewTipTapRoute
  '/posts/tipy-tap': typeof AuthenticatedPostsTipyTapRoute
  '/profiles/new': typeof AuthenticatedProfilesNewRoute
  '/residents/$id': typeof AuthenticatedResidentsIdRoute
  '/residents/map': typeof AuthenticatedResidentsMapRoute
  '/residents/new': typeof AuthenticatedResidentsNewRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/facebook-success': typeof AuthenticatedSettingsFacebookSuccessRoute
  '/settings/info': typeof AuthenticatedSettingsInfoRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/organizations': typeof AuthenticatedSettingsOrganizationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/surveys/new': typeof AuthenticatedSurveysNewRoute
  '/web-links/$webLinkId': typeof AuthenticatedWebLinksWebLinkIdRoute
  '/web-links/new': typeof AuthenticatedWebLinksNewRoute
  '/p/$postId': typeof PublicPPostIdRoute
  '/app': typeof AuthenticatedAppIndexRoute
  '/calendar': typeof AuthenticatedCalendarIndexRoute
  '/calendars': typeof AuthenticatedCalendarsIndexRoute
  '/conversations': typeof AuthenticatedConversationsIndexRoute
  '/home': typeof AuthenticatedHomeIndexRoute
  '/incidents': typeof AuthenticatedIncidentsIndexRoute
  '/media': typeof AuthenticatedMediaIndexRoute
  '/meetings': typeof AuthenticatedMeetingsIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/places': typeof AuthenticatedPlacesIndexRoute
  '/posts': typeof AuthenticatedPostsIndexRoute
  '/residents': typeof AuthenticatedResidentsIndexRoute
  '/super-admin': typeof AuthenticatedSuperAdminIndexRoute
  '/surveys': typeof AuthenticatedSurveysIndexRoute
  '/web-links': typeof AuthenticatedWebLinksIndexRoute
  '/website': typeof AuthenticatedWebsiteIndexRoute
  '/app/quick-access/new': typeof AuthenticatedAppQuickAccessNewRoute
  '/super-admin/organizations/list': typeof AuthenticatedSuperAdminOrganizationsListRoute
  '/super-admin/organizations/new': typeof AuthenticatedSuperAdminOrganizationsNewRoute
  '/app/feed/': typeof AuthenticatedAppFeedIndexRoute
  '/app/home': typeof AuthenticatedAppHomeIndexRoute
  '/app/quick-access/': typeof AuthenticatedAppQuickAccessIndexRoute
  '/calendar/$calendarId': typeof AuthenticatedCalendarCalendarIdIndexRoute
  '/super-admin/organizations': typeof AuthenticatedSuperAdminOrganizationsIndexRoute
  '/website/disclosures': typeof AuthenticatedWebsiteDisclosuresIndexRoute
  '/website/documents': typeof AuthenticatedWebsiteDocumentsIndexRoute
  '/website/downloads': typeof AuthenticatedWebsiteDownloadsIndexRoute
  '/website/events': typeof AuthenticatedWebsiteEventsIndexRoute
  '/website/government-documents': typeof AuthenticatedWebsiteGovernmentDocumentsIndexRoute
  '/website/jobs': typeof AuthenticatedWebsiteJobsIndexRoute
  '/website/news-notices': typeof AuthenticatedWebsiteNewsNoticesIndexRoute
  '/website/notices': typeof AuthenticatedWebsiteNoticesIndexRoute
  '/website/staff-directory': typeof AuthenticatedWebsiteStaffDirectoryIndexRoute
  '/app/feed/categories/$categoryId': typeof AuthenticatedAppFeedCategoriesCategoryIdRoute
  '/app/feed/categories/new': typeof AuthenticatedAppFeedCategoriesNewRoute
  '/app/quick-access/sections/$sectionId': typeof AuthenticatedAppQuickAccessSectionsSectionIdRoute
  '/app/quick-access/sections/new': typeof AuthenticatedAppQuickAccessSectionsNewRoute
  '/calendar/$calendarId/events/$eventId': typeof AuthenticatedCalendarCalendarIdEventsEventIdRoute
  '/calendar/$calendarId/events/new': typeof AuthenticatedCalendarCalendarIdEventsNewRoute
  '/super-admin/organizations/$organizationId/edit': typeof AuthenticatedSuperAdminOrganizationsOrganizationIdEditRoute
  '/app/feed/categories': typeof AuthenticatedAppFeedCategoriesIndexRoute
  '/app/quick-access/sections': typeof AuthenticatedAppQuickAccessSectionsIndexRoute
  '/calendar/$calendarId/events': typeof AuthenticatedCalendarCalendarIdEventsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/ai': typeof AuthenticatedAiRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/feed': typeof AuthenticatedFeedRoute
  '/library': typeof AuthenticatedLibraryRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/stories': typeof AuthenticatedStoriesRoute
  '/reset-success': typeof PublicResetSuccessRoute
  '/app/pinned-posts': typeof AuthenticatedAppPinnedPostsRoute
  '/app/posts': typeof AuthenticatedAppPostsRoute
  '/app/stories': typeof AuthenticatedAppStoriesRoute
  '/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/conversations/new': typeof AuthenticatedConversationsNewRoute
  '/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/links/translations': typeof AuthenticatedLinksTranslationsRoute
  '/media/$mediaId': typeof AuthenticatedMediaMediaIdRoute
  '/media/grid': typeof AuthenticatedMediaGridRoute
  '/media/new': typeof AuthenticatedMediaNewRoute
  '/meetings/$meetingId': typeof AuthenticatedMeetingsMeetingIdRoute
  '/meetings/new': typeof AuthenticatedMeetingsNewRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/places/$placeId': typeof AuthenticatedPlacesPlaceIdRoute
  '/places/new': typeof AuthenticatedPlacesNewRoute
  '/posts/$postId': typeof AuthenticatedPostsPostIdRoute
  '/posts/new': typeof AuthenticatedPostsNewRoute
  '/posts/new-page': typeof AuthenticatedPostsNewPageRoute
  '/posts/new-tip-tap': typeof AuthenticatedPostsNewTipTapRoute
  '/posts/tipy-tap': typeof AuthenticatedPostsTipyTapRoute
  '/profiles/new': typeof AuthenticatedProfilesNewRoute
  '/residents/$id': typeof AuthenticatedResidentsIdRoute
  '/residents/map': typeof AuthenticatedResidentsMapRoute
  '/residents/new': typeof AuthenticatedResidentsNewRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/facebook-success': typeof AuthenticatedSettingsFacebookSuccessRoute
  '/settings/info': typeof AuthenticatedSettingsInfoRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/organizations': typeof AuthenticatedSettingsOrganizationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/surveys/new': typeof AuthenticatedSurveysNewRoute
  '/web-links/$webLinkId': typeof AuthenticatedWebLinksWebLinkIdRoute
  '/web-links/new': typeof AuthenticatedWebLinksNewRoute
  '/p/$postId': typeof PublicPPostIdRoute
  '/app': typeof AuthenticatedAppIndexRoute
  '/calendar': typeof AuthenticatedCalendarIndexRoute
  '/calendars': typeof AuthenticatedCalendarsIndexRoute
  '/conversations': typeof AuthenticatedConversationsIndexRoute
  '/home': typeof AuthenticatedHomeIndexRoute
  '/incidents': typeof AuthenticatedIncidentsIndexRoute
  '/media': typeof AuthenticatedMediaIndexRoute
  '/meetings': typeof AuthenticatedMeetingsIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/places': typeof AuthenticatedPlacesIndexRoute
  '/posts': typeof AuthenticatedPostsIndexRoute
  '/residents': typeof AuthenticatedResidentsIndexRoute
  '/super-admin': typeof AuthenticatedSuperAdminIndexRoute
  '/surveys': typeof AuthenticatedSurveysIndexRoute
  '/web-links': typeof AuthenticatedWebLinksIndexRoute
  '/website': typeof AuthenticatedWebsiteIndexRoute
  '/app/quick-access/new': typeof AuthenticatedAppQuickAccessNewRoute
  '/super-admin/organizations/list': typeof AuthenticatedSuperAdminOrganizationsListRoute
  '/super-admin/organizations/new': typeof AuthenticatedSuperAdminOrganizationsNewRoute
  '/app/feed': typeof AuthenticatedAppFeedIndexRoute
  '/app/home': typeof AuthenticatedAppHomeIndexRoute
  '/app/quick-access': typeof AuthenticatedAppQuickAccessIndexRoute
  '/calendar/$calendarId': typeof AuthenticatedCalendarCalendarIdIndexRoute
  '/super-admin/organizations': typeof AuthenticatedSuperAdminOrganizationsIndexRoute
  '/website/disclosures': typeof AuthenticatedWebsiteDisclosuresIndexRoute
  '/website/documents': typeof AuthenticatedWebsiteDocumentsIndexRoute
  '/website/downloads': typeof AuthenticatedWebsiteDownloadsIndexRoute
  '/website/events': typeof AuthenticatedWebsiteEventsIndexRoute
  '/website/government-documents': typeof AuthenticatedWebsiteGovernmentDocumentsIndexRoute
  '/website/jobs': typeof AuthenticatedWebsiteJobsIndexRoute
  '/website/news-notices': typeof AuthenticatedWebsiteNewsNoticesIndexRoute
  '/website/notices': typeof AuthenticatedWebsiteNoticesIndexRoute
  '/website/staff-directory': typeof AuthenticatedWebsiteStaffDirectoryIndexRoute
  '/app/feed/categories/$categoryId': typeof AuthenticatedAppFeedCategoriesCategoryIdRoute
  '/app/feed/categories/new': typeof AuthenticatedAppFeedCategoriesNewRoute
  '/app/quick-access/sections/$sectionId': typeof AuthenticatedAppQuickAccessSectionsSectionIdRoute
  '/app/quick-access/sections/new': typeof AuthenticatedAppQuickAccessSectionsNewRoute
  '/calendar/$calendarId/events/$eventId': typeof AuthenticatedCalendarCalendarIdEventsEventIdRoute
  '/calendar/$calendarId/events/new': typeof AuthenticatedCalendarCalendarIdEventsNewRoute
  '/super-admin/organizations/$organizationId/edit': typeof AuthenticatedSuperAdminOrganizationsOrganizationIdEditRoute
  '/app/feed/categories': typeof AuthenticatedAppFeedCategoriesIndexRoute
  '/app/quick-access/sections': typeof AuthenticatedAppQuickAccessSectionsIndexRoute
  '/calendar/$calendarId/events': typeof AuthenticatedCalendarCalendarIdEventsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_layout': typeof LayoutRoute
  '/_public': typeof PublicRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/ai': typeof AuthenticatedAiRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/feed': typeof AuthenticatedFeedRoute
  '/_authenticated/library': typeof AuthenticatedLibraryRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/stories': typeof AuthenticatedStoriesRoute
  '/_public/reset-success': typeof PublicResetSuccessRoute
  '/_authenticated/app/feed': typeof AuthenticatedAppFeedRouteWithChildren
  '/_authenticated/app/pinned-posts': typeof AuthenticatedAppPinnedPostsRoute
  '/_authenticated/app/posts': typeof AuthenticatedAppPostsRoute
  '/_authenticated/app/quick-access': typeof AuthenticatedAppQuickAccessRouteWithChildren
  '/_authenticated/app/stories': typeof AuthenticatedAppStoriesRoute
  '/_authenticated/conversations/$conversationId': typeof AuthenticatedConversationsConversationIdRoute
  '/_authenticated/conversations/new': typeof AuthenticatedConversationsNewRoute
  '/_authenticated/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/_authenticated/links/translations': typeof AuthenticatedLinksTranslationsRoute
  '/_authenticated/media/$mediaId': typeof AuthenticatedMediaMediaIdRoute
  '/_authenticated/media/grid': typeof AuthenticatedMediaGridRoute
  '/_authenticated/media/new': typeof AuthenticatedMediaNewRoute
  '/_authenticated/meetings/$meetingId': typeof AuthenticatedMeetingsMeetingIdRoute
  '/_authenticated/meetings/new': typeof AuthenticatedMeetingsNewRoute
  '/_authenticated/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/_authenticated/places/$placeId': typeof AuthenticatedPlacesPlaceIdRoute
  '/_authenticated/places/new': typeof AuthenticatedPlacesNewRoute
  '/_authenticated/posts/$postId': typeof AuthenticatedPostsPostIdRoute
  '/_authenticated/posts/new': typeof AuthenticatedPostsNewRoute
  '/_authenticated/posts/new-page': typeof AuthenticatedPostsNewPageRoute
  '/_authenticated/posts/new-tip-tap': typeof AuthenticatedPostsNewTipTapRoute
  '/_authenticated/posts/tipy-tap': typeof AuthenticatedPostsTipyTapRoute
  '/_authenticated/profiles/new': typeof AuthenticatedProfilesNewRoute
  '/_authenticated/residents/$id': typeof AuthenticatedResidentsIdRoute
  '/_authenticated/residents/map': typeof AuthenticatedResidentsMapRoute
  '/_authenticated/residents/new': typeof AuthenticatedResidentsNewRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/facebook-success': typeof AuthenticatedSettingsFacebookSuccessRoute
  '/_authenticated/settings/info': typeof AuthenticatedSettingsInfoRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/organizations': typeof AuthenticatedSettingsOrganizationsRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/_authenticated/surveys/new': typeof AuthenticatedSurveysNewRoute
  '/_authenticated/web-links/$webLinkId': typeof AuthenticatedWebLinksWebLinkIdRoute
  '/_authenticated/web-links/new': typeof AuthenticatedWebLinksNewRoute
  '/_public/p/$postId': typeof PublicPPostIdRoute
  '/_authenticated/app/': typeof AuthenticatedAppIndexRoute
  '/_authenticated/calendar/': typeof AuthenticatedCalendarIndexRoute
  '/_authenticated/calendars/': typeof AuthenticatedCalendarsIndexRoute
  '/_authenticated/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/_authenticated/home/': typeof AuthenticatedHomeIndexRoute
  '/_authenticated/incidents/': typeof AuthenticatedIncidentsIndexRoute
  '/_authenticated/media/': typeof AuthenticatedMediaIndexRoute
  '/_authenticated/meetings/': typeof AuthenticatedMeetingsIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/places/': typeof AuthenticatedPlacesIndexRoute
  '/_authenticated/posts/': typeof AuthenticatedPostsIndexRoute
  '/_authenticated/residents/': typeof AuthenticatedResidentsIndexRoute
  '/_authenticated/super-admin/': typeof AuthenticatedSuperAdminIndexRoute
  '/_authenticated/surveys/': typeof AuthenticatedSurveysIndexRoute
  '/_authenticated/web-links/': typeof AuthenticatedWebLinksIndexRoute
  '/_authenticated/website/': typeof AuthenticatedWebsiteIndexRoute
  '/_authenticated/app/quick-access/new': typeof AuthenticatedAppQuickAccessNewRoute
  '/_authenticated/super-admin/organizations/list': typeof AuthenticatedSuperAdminOrganizationsListRoute
  '/_authenticated/super-admin/organizations/new': typeof AuthenticatedSuperAdminOrganizationsNewRoute
  '/_authenticated/app/feed/': typeof AuthenticatedAppFeedIndexRoute
  '/_authenticated/app/home/': typeof AuthenticatedAppHomeIndexRoute
  '/_authenticated/app/quick-access/': typeof AuthenticatedAppQuickAccessIndexRoute
  '/_authenticated/calendar/$calendarId/': typeof AuthenticatedCalendarCalendarIdIndexRoute
  '/_authenticated/super-admin/organizations/': typeof AuthenticatedSuperAdminOrganizationsIndexRoute
  '/_authenticated/website/disclosures/': typeof AuthenticatedWebsiteDisclosuresIndexRoute
  '/_authenticated/website/documents/': typeof AuthenticatedWebsiteDocumentsIndexRoute
  '/_authenticated/website/downloads/': typeof AuthenticatedWebsiteDownloadsIndexRoute
  '/_authenticated/website/events/': typeof AuthenticatedWebsiteEventsIndexRoute
  '/_authenticated/website/government-documents/': typeof AuthenticatedWebsiteGovernmentDocumentsIndexRoute
  '/_authenticated/website/jobs/': typeof AuthenticatedWebsiteJobsIndexRoute
  '/_authenticated/website/news-notices/': typeof AuthenticatedWebsiteNewsNoticesIndexRoute
  '/_authenticated/website/notices/': typeof AuthenticatedWebsiteNoticesIndexRoute
  '/_authenticated/website/staff-directory/': typeof AuthenticatedWebsiteStaffDirectoryIndexRoute
  '/_authenticated/app/feed/categories/$categoryId': typeof AuthenticatedAppFeedCategoriesCategoryIdRoute
  '/_authenticated/app/feed/categories/new': typeof AuthenticatedAppFeedCategoriesNewRoute
  '/_authenticated/app/quick-access/sections/$sectionId': typeof AuthenticatedAppQuickAccessSectionsSectionIdRoute
  '/_authenticated/app/quick-access/sections/new': typeof AuthenticatedAppQuickAccessSectionsNewRoute
  '/_authenticated/calendar/$calendarId/events/$eventId': typeof AuthenticatedCalendarCalendarIdEventsEventIdRoute
  '/_authenticated/calendar/$calendarId/events/new': typeof AuthenticatedCalendarCalendarIdEventsNewRoute
  '/_authenticated/super-admin/organizations/$organizationId/edit': typeof AuthenticatedSuperAdminOrganizationsOrganizationIdEditRoute
  '/_authenticated/app/feed/categories/': typeof AuthenticatedAppFeedCategoriesIndexRoute
  '/_authenticated/app/quick-access/sections/': typeof AuthenticatedAppQuickAccessSectionsIndexRoute
  '/_authenticated/calendar/$calendarId/events/': typeof AuthenticatedCalendarCalendarIdEventsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/ai'
    | '/dashboard'
    | '/feed'
    | '/library'
    | '/settings'
    | '/stories'
    | '/reset-success'
    | '/app/feed'
    | '/app/pinned-posts'
    | '/app/posts'
    | '/app/quick-access'
    | '/app/stories'
    | '/conversations/$conversationId'
    | '/conversations/new'
    | '/incidents/$incidentId'
    | '/links/translations'
    | '/media/$mediaId'
    | '/media/grid'
    | '/media/new'
    | '/meetings/$meetingId'
    | '/meetings/new'
    | '/notifications/new'
    | '/places/$placeId'
    | '/places/new'
    | '/posts/$postId'
    | '/posts/new'
    | '/posts/new-page'
    | '/posts/new-tip-tap'
    | '/posts/tipy-tap'
    | '/profiles/new'
    | '/residents/$id'
    | '/residents/map'
    | '/residents/new'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/connections'
    | '/settings/display'
    | '/settings/facebook-success'
    | '/settings/info'
    | '/settings/notifications'
    | '/settings/organizations'
    | '/settings/profile'
    | '/settings/users'
    | '/surveys/new'
    | '/web-links/$webLinkId'
    | '/web-links/new'
    | '/p/$postId'
    | '/app'
    | '/calendar'
    | '/calendars'
    | '/conversations'
    | '/home'
    | '/incidents'
    | '/media'
    | '/meetings'
    | '/notifications'
    | '/places'
    | '/posts'
    | '/residents'
    | '/super-admin'
    | '/surveys'
    | '/web-links'
    | '/website'
    | '/app/quick-access/new'
    | '/super-admin/organizations/list'
    | '/super-admin/organizations/new'
    | '/app/feed/'
    | '/app/home'
    | '/app/quick-access/'
    | '/calendar/$calendarId'
    | '/super-admin/organizations'
    | '/website/disclosures'
    | '/website/documents'
    | '/website/downloads'
    | '/website/events'
    | '/website/government-documents'
    | '/website/jobs'
    | '/website/news-notices'
    | '/website/notices'
    | '/website/staff-directory'
    | '/app/feed/categories/$categoryId'
    | '/app/feed/categories/new'
    | '/app/quick-access/sections/$sectionId'
    | '/app/quick-access/sections/new'
    | '/calendar/$calendarId/events/$eventId'
    | '/calendar/$calendarId/events/new'
    | '/super-admin/organizations/$organizationId/edit'
    | '/app/feed/categories'
    | '/app/quick-access/sections'
    | '/calendar/$calendarId/events'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/reset-password'
    | '/ai'
    | '/dashboard'
    | '/feed'
    | '/library'
    | '/settings'
    | '/stories'
    | '/reset-success'
    | '/app/pinned-posts'
    | '/app/posts'
    | '/app/stories'
    | '/conversations/$conversationId'
    | '/conversations/new'
    | '/incidents/$incidentId'
    | '/links/translations'
    | '/media/$mediaId'
    | '/media/grid'
    | '/media/new'
    | '/meetings/$meetingId'
    | '/meetings/new'
    | '/notifications/new'
    | '/places/$placeId'
    | '/places/new'
    | '/posts/$postId'
    | '/posts/new'
    | '/posts/new-page'
    | '/posts/new-tip-tap'
    | '/posts/tipy-tap'
    | '/profiles/new'
    | '/residents/$id'
    | '/residents/map'
    | '/residents/new'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/connections'
    | '/settings/display'
    | '/settings/facebook-success'
    | '/settings/info'
    | '/settings/notifications'
    | '/settings/organizations'
    | '/settings/profile'
    | '/settings/users'
    | '/surveys/new'
    | '/web-links/$webLinkId'
    | '/web-links/new'
    | '/p/$postId'
    | '/app'
    | '/calendar'
    | '/calendars'
    | '/conversations'
    | '/home'
    | '/incidents'
    | '/media'
    | '/meetings'
    | '/notifications'
    | '/places'
    | '/posts'
    | '/residents'
    | '/super-admin'
    | '/surveys'
    | '/web-links'
    | '/website'
    | '/app/quick-access/new'
    | '/super-admin/organizations/list'
    | '/super-admin/organizations/new'
    | '/app/feed'
    | '/app/home'
    | '/app/quick-access'
    | '/calendar/$calendarId'
    | '/super-admin/organizations'
    | '/website/disclosures'
    | '/website/documents'
    | '/website/downloads'
    | '/website/events'
    | '/website/government-documents'
    | '/website/jobs'
    | '/website/news-notices'
    | '/website/notices'
    | '/website/staff-directory'
    | '/app/feed/categories/$categoryId'
    | '/app/feed/categories/new'
    | '/app/quick-access/sections/$sectionId'
    | '/app/quick-access/sections/new'
    | '/calendar/$calendarId/events/$eventId'
    | '/calendar/$calendarId/events/new'
    | '/super-admin/organizations/$organizationId/edit'
    | '/app/feed/categories'
    | '/app/quick-access/sections'
    | '/calendar/$calendarId/events'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_layout'
    | '/_public'
    | '/login'
    | '/reset-password'
    | '/_authenticated/ai'
    | '/_authenticated/dashboard'
    | '/_authenticated/feed'
    | '/_authenticated/library'
    | '/_authenticated/settings'
    | '/_authenticated/stories'
    | '/_public/reset-success'
    | '/_authenticated/app/feed'
    | '/_authenticated/app/pinned-posts'
    | '/_authenticated/app/posts'
    | '/_authenticated/app/quick-access'
    | '/_authenticated/app/stories'
    | '/_authenticated/conversations/$conversationId'
    | '/_authenticated/conversations/new'
    | '/_authenticated/incidents/$incidentId'
    | '/_authenticated/links/translations'
    | '/_authenticated/media/$mediaId'
    | '/_authenticated/media/grid'
    | '/_authenticated/media/new'
    | '/_authenticated/meetings/$meetingId'
    | '/_authenticated/meetings/new'
    | '/_authenticated/notifications/new'
    | '/_authenticated/places/$placeId'
    | '/_authenticated/places/new'
    | '/_authenticated/posts/$postId'
    | '/_authenticated/posts/new'
    | '/_authenticated/posts/new-page'
    | '/_authenticated/posts/new-tip-tap'
    | '/_authenticated/posts/tipy-tap'
    | '/_authenticated/profiles/new'
    | '/_authenticated/residents/$id'
    | '/_authenticated/residents/map'
    | '/_authenticated/residents/new'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/connections'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/facebook-success'
    | '/_authenticated/settings/info'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/organizations'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/users'
    | '/_authenticated/surveys/new'
    | '/_authenticated/web-links/$webLinkId'
    | '/_authenticated/web-links/new'
    | '/_public/p/$postId'
    | '/_authenticated/app/'
    | '/_authenticated/calendar/'
    | '/_authenticated/calendars/'
    | '/_authenticated/conversations/'
    | '/_authenticated/home/'
    | '/_authenticated/incidents/'
    | '/_authenticated/media/'
    | '/_authenticated/meetings/'
    | '/_authenticated/notifications/'
    | '/_authenticated/places/'
    | '/_authenticated/posts/'
    | '/_authenticated/residents/'
    | '/_authenticated/super-admin/'
    | '/_authenticated/surveys/'
    | '/_authenticated/web-links/'
    | '/_authenticated/website/'
    | '/_authenticated/app/quick-access/new'
    | '/_authenticated/super-admin/organizations/list'
    | '/_authenticated/super-admin/organizations/new'
    | '/_authenticated/app/feed/'
    | '/_authenticated/app/home/'
    | '/_authenticated/app/quick-access/'
    | '/_authenticated/calendar/$calendarId/'
    | '/_authenticated/super-admin/organizations/'
    | '/_authenticated/website/disclosures/'
    | '/_authenticated/website/documents/'
    | '/_authenticated/website/downloads/'
    | '/_authenticated/website/events/'
    | '/_authenticated/website/government-documents/'
    | '/_authenticated/website/jobs/'
    | '/_authenticated/website/news-notices/'
    | '/_authenticated/website/notices/'
    | '/_authenticated/website/staff-directory/'
    | '/_authenticated/app/feed/categories/$categoryId'
    | '/_authenticated/app/feed/categories/new'
    | '/_authenticated/app/quick-access/sections/$sectionId'
    | '/_authenticated/app/quick-access/sections/new'
    | '/_authenticated/calendar/$calendarId/events/$eventId'
    | '/_authenticated/calendar/$calendarId/events/new'
    | '/_authenticated/super-admin/organizations/$organizationId/edit'
    | '/_authenticated/app/feed/categories/'
    | '/_authenticated/app/quick-access/sections/'
    | '/_authenticated/calendar/$calendarId/events/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LayoutRoute: typeof LayoutRoute
  PublicRoute: typeof PublicRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/reset-success': {
      id: '/_public/reset-success'
      path: '/reset-success'
      fullPath: '/reset-success'
      preLoaderRoute: typeof PublicResetSuccessRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/stories': {
      id: '/_authenticated/stories'
      path: '/stories'
      fullPath: '/stories'
      preLoaderRoute: typeof AuthenticatedStoriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/library': {
      id: '/_authenticated/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof AuthenticatedLibraryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feed': {
      id: '/_authenticated/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof AuthenticatedFeedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai': {
      id: '/_authenticated/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AuthenticatedAiRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/': {
      id: '/_authenticated/website/'
      path: '/website'
      fullPath: '/website'
      preLoaderRoute: typeof AuthenticatedWebsiteIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/web-links/': {
      id: '/_authenticated/web-links/'
      path: '/web-links'
      fullPath: '/web-links'
      preLoaderRoute: typeof AuthenticatedWebLinksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/surveys/': {
      id: '/_authenticated/surveys/'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof AuthenticatedSurveysIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/super-admin/': {
      id: '/_authenticated/super-admin/'
      path: '/super-admin'
      fullPath: '/super-admin'
      preLoaderRoute: typeof AuthenticatedSuperAdminIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/residents/': {
      id: '/_authenticated/residents/'
      path: '/residents'
      fullPath: '/residents'
      preLoaderRoute: typeof AuthenticatedResidentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/': {
      id: '/_authenticated/posts/'
      path: '/posts'
      fullPath: '/posts'
      preLoaderRoute: typeof AuthenticatedPostsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/places/': {
      id: '/_authenticated/places/'
      path: '/places'
      fullPath: '/places'
      preLoaderRoute: typeof AuthenticatedPlacesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meetings/': {
      id: '/_authenticated/meetings/'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof AuthenticatedMeetingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/media/': {
      id: '/_authenticated/media/'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof AuthenticatedMediaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents/': {
      id: '/_authenticated/incidents/'
      path: '/incidents'
      fullPath: '/incidents'
      preLoaderRoute: typeof AuthenticatedIncidentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/': {
      id: '/_authenticated/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversations/': {
      id: '/_authenticated/conversations/'
      path: '/conversations'
      fullPath: '/conversations'
      preLoaderRoute: typeof AuthenticatedConversationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendars/': {
      id: '/_authenticated/calendars/'
      path: '/calendars'
      fullPath: '/calendars'
      preLoaderRoute: typeof AuthenticatedCalendarsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/': {
      id: '/_authenticated/calendar/'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/': {
      id: '/_authenticated/app/'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AuthenticatedAppIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/p/$postId': {
      id: '/_public/p/$postId'
      path: '/p/$postId'
      fullPath: '/p/$postId'
      preLoaderRoute: typeof PublicPPostIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/web-links/new': {
      id: '/_authenticated/web-links/new'
      path: '/web-links/new'
      fullPath: '/web-links/new'
      preLoaderRoute: typeof AuthenticatedWebLinksNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/web-links/$webLinkId': {
      id: '/_authenticated/web-links/$webLinkId'
      path: '/web-links/$webLinkId'
      fullPath: '/web-links/$webLinkId'
      preLoaderRoute: typeof AuthenticatedWebLinksWebLinkIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/surveys/new': {
      id: '/_authenticated/surveys/new'
      path: '/surveys/new'
      fullPath: '/surveys/new'
      preLoaderRoute: typeof AuthenticatedSurveysNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/users': {
      id: '/_authenticated/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/organizations': {
      id: '/_authenticated/settings/organizations'
      path: '/organizations'
      fullPath: '/settings/organizations'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/info': {
      id: '/_authenticated/settings/info'
      path: '/info'
      fullPath: '/settings/info'
      preLoaderRoute: typeof AuthenticatedSettingsInfoRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/facebook-success': {
      id: '/_authenticated/settings/facebook-success'
      path: '/facebook-success'
      fullPath: '/settings/facebook-success'
      preLoaderRoute: typeof AuthenticatedSettingsFacebookSuccessRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/connections': {
      id: '/_authenticated/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof AuthenticatedSettingsConnectionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/residents/new': {
      id: '/_authenticated/residents/new'
      path: '/residents/new'
      fullPath: '/residents/new'
      preLoaderRoute: typeof AuthenticatedResidentsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/residents/map': {
      id: '/_authenticated/residents/map'
      path: '/residents/map'
      fullPath: '/residents/map'
      preLoaderRoute: typeof AuthenticatedResidentsMapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/residents/$id': {
      id: '/_authenticated/residents/$id'
      path: '/residents/$id'
      fullPath: '/residents/$id'
      preLoaderRoute: typeof AuthenticatedResidentsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profiles/new': {
      id: '/_authenticated/profiles/new'
      path: '/profiles/new'
      fullPath: '/profiles/new'
      preLoaderRoute: typeof AuthenticatedProfilesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/tipy-tap': {
      id: '/_authenticated/posts/tipy-tap'
      path: '/posts/tipy-tap'
      fullPath: '/posts/tipy-tap'
      preLoaderRoute: typeof AuthenticatedPostsTipyTapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/new-tip-tap': {
      id: '/_authenticated/posts/new-tip-tap'
      path: '/posts/new-tip-tap'
      fullPath: '/posts/new-tip-tap'
      preLoaderRoute: typeof AuthenticatedPostsNewTipTapRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/new-page': {
      id: '/_authenticated/posts/new-page'
      path: '/posts/new-page'
      fullPath: '/posts/new-page'
      preLoaderRoute: typeof AuthenticatedPostsNewPageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/new': {
      id: '/_authenticated/posts/new'
      path: '/posts/new'
      fullPath: '/posts/new'
      preLoaderRoute: typeof AuthenticatedPostsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/posts/$postId': {
      id: '/_authenticated/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/posts/$postId'
      preLoaderRoute: typeof AuthenticatedPostsPostIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/places/new': {
      id: '/_authenticated/places/new'
      path: '/places/new'
      fullPath: '/places/new'
      preLoaderRoute: typeof AuthenticatedPlacesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/places/$placeId': {
      id: '/_authenticated/places/$placeId'
      path: '/places/$placeId'
      fullPath: '/places/$placeId'
      preLoaderRoute: typeof AuthenticatedPlacesPlaceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications/new': {
      id: '/_authenticated/notifications/new'
      path: '/notifications/new'
      fullPath: '/notifications/new'
      preLoaderRoute: typeof AuthenticatedNotificationsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meetings/new': {
      id: '/_authenticated/meetings/new'
      path: '/meetings/new'
      fullPath: '/meetings/new'
      preLoaderRoute: typeof AuthenticatedMeetingsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meetings/$meetingId': {
      id: '/_authenticated/meetings/$meetingId'
      path: '/meetings/$meetingId'
      fullPath: '/meetings/$meetingId'
      preLoaderRoute: typeof AuthenticatedMeetingsMeetingIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/media/new': {
      id: '/_authenticated/media/new'
      path: '/media/new'
      fullPath: '/media/new'
      preLoaderRoute: typeof AuthenticatedMediaNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/media/grid': {
      id: '/_authenticated/media/grid'
      path: '/media/grid'
      fullPath: '/media/grid'
      preLoaderRoute: typeof AuthenticatedMediaGridRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/media/$mediaId': {
      id: '/_authenticated/media/$mediaId'
      path: '/media/$mediaId'
      fullPath: '/media/$mediaId'
      preLoaderRoute: typeof AuthenticatedMediaMediaIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/links/translations': {
      id: '/_authenticated/links/translations'
      path: '/links/translations'
      fullPath: '/links/translations'
      preLoaderRoute: typeof AuthenticatedLinksTranslationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents/$incidentId': {
      id: '/_authenticated/incidents/$incidentId'
      path: '/incidents/$incidentId'
      fullPath: '/incidents/$incidentId'
      preLoaderRoute: typeof AuthenticatedIncidentsIncidentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversations/new': {
      id: '/_authenticated/conversations/new'
      path: '/conversations/new'
      fullPath: '/conversations/new'
      preLoaderRoute: typeof AuthenticatedConversationsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversations/$conversationId': {
      id: '/_authenticated/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/conversations/$conversationId'
      preLoaderRoute: typeof AuthenticatedConversationsConversationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/stories': {
      id: '/_authenticated/app/stories'
      path: '/app/stories'
      fullPath: '/app/stories'
      preLoaderRoute: typeof AuthenticatedAppStoriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/quick-access': {
      id: '/_authenticated/app/quick-access'
      path: '/app/quick-access'
      fullPath: '/app/quick-access'
      preLoaderRoute: typeof AuthenticatedAppQuickAccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/posts': {
      id: '/_authenticated/app/posts'
      path: '/app/posts'
      fullPath: '/app/posts'
      preLoaderRoute: typeof AuthenticatedAppPostsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/pinned-posts': {
      id: '/_authenticated/app/pinned-posts'
      path: '/app/pinned-posts'
      fullPath: '/app/pinned-posts'
      preLoaderRoute: typeof AuthenticatedAppPinnedPostsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/feed': {
      id: '/_authenticated/app/feed'
      path: '/app/feed'
      fullPath: '/app/feed'
      preLoaderRoute: typeof AuthenticatedAppFeedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/staff-directory/': {
      id: '/_authenticated/website/staff-directory/'
      path: '/website/staff-directory'
      fullPath: '/website/staff-directory'
      preLoaderRoute: typeof AuthenticatedWebsiteStaffDirectoryIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/notices/': {
      id: '/_authenticated/website/notices/'
      path: '/website/notices'
      fullPath: '/website/notices'
      preLoaderRoute: typeof AuthenticatedWebsiteNoticesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/news-notices/': {
      id: '/_authenticated/website/news-notices/'
      path: '/website/news-notices'
      fullPath: '/website/news-notices'
      preLoaderRoute: typeof AuthenticatedWebsiteNewsNoticesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/jobs/': {
      id: '/_authenticated/website/jobs/'
      path: '/website/jobs'
      fullPath: '/website/jobs'
      preLoaderRoute: typeof AuthenticatedWebsiteJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/government-documents/': {
      id: '/_authenticated/website/government-documents/'
      path: '/website/government-documents'
      fullPath: '/website/government-documents'
      preLoaderRoute: typeof AuthenticatedWebsiteGovernmentDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/events/': {
      id: '/_authenticated/website/events/'
      path: '/website/events'
      fullPath: '/website/events'
      preLoaderRoute: typeof AuthenticatedWebsiteEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/downloads/': {
      id: '/_authenticated/website/downloads/'
      path: '/website/downloads'
      fullPath: '/website/downloads'
      preLoaderRoute: typeof AuthenticatedWebsiteDownloadsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/documents/': {
      id: '/_authenticated/website/documents/'
      path: '/website/documents'
      fullPath: '/website/documents'
      preLoaderRoute: typeof AuthenticatedWebsiteDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/disclosures/': {
      id: '/_authenticated/website/disclosures/'
      path: '/website/disclosures'
      fullPath: '/website/disclosures'
      preLoaderRoute: typeof AuthenticatedWebsiteDisclosuresIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/super-admin/organizations/': {
      id: '/_authenticated/super-admin/organizations/'
      path: '/super-admin/organizations'
      fullPath: '/super-admin/organizations'
      preLoaderRoute: typeof AuthenticatedSuperAdminOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/$calendarId/': {
      id: '/_authenticated/calendar/$calendarId/'
      path: '/calendar/$calendarId'
      fullPath: '/calendar/$calendarId'
      preLoaderRoute: typeof AuthenticatedCalendarCalendarIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/quick-access/': {
      id: '/_authenticated/app/quick-access/'
      path: '/'
      fullPath: '/app/quick-access/'
      preLoaderRoute: typeof AuthenticatedAppQuickAccessIndexRouteImport
      parentRoute: typeof AuthenticatedAppQuickAccessRoute
    }
    '/_authenticated/app/home/': {
      id: '/_authenticated/app/home/'
      path: '/app/home'
      fullPath: '/app/home'
      preLoaderRoute: typeof AuthenticatedAppHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/feed/': {
      id: '/_authenticated/app/feed/'
      path: '/'
      fullPath: '/app/feed/'
      preLoaderRoute: typeof AuthenticatedAppFeedIndexRouteImport
      parentRoute: typeof AuthenticatedAppFeedRoute
    }
    '/_authenticated/super-admin/organizations/new': {
      id: '/_authenticated/super-admin/organizations/new'
      path: '/super-admin/organizations/new'
      fullPath: '/super-admin/organizations/new'
      preLoaderRoute: typeof AuthenticatedSuperAdminOrganizationsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/super-admin/organizations/list': {
      id: '/_authenticated/super-admin/organizations/list'
      path: '/super-admin/organizations/list'
      fullPath: '/super-admin/organizations/list'
      preLoaderRoute: typeof AuthenticatedSuperAdminOrganizationsListRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/quick-access/new': {
      id: '/_authenticated/app/quick-access/new'
      path: '/new'
      fullPath: '/app/quick-access/new'
      preLoaderRoute: typeof AuthenticatedAppQuickAccessNewRouteImport
      parentRoute: typeof AuthenticatedAppQuickAccessRoute
    }
    '/_authenticated/calendar/$calendarId/events/': {
      id: '/_authenticated/calendar/$calendarId/events/'
      path: '/calendar/$calendarId/events'
      fullPath: '/calendar/$calendarId/events'
      preLoaderRoute: typeof AuthenticatedCalendarCalendarIdEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/quick-access/sections/': {
      id: '/_authenticated/app/quick-access/sections/'
      path: '/sections'
      fullPath: '/app/quick-access/sections'
      preLoaderRoute: typeof AuthenticatedAppQuickAccessSectionsIndexRouteImport
      parentRoute: typeof AuthenticatedAppQuickAccessRoute
    }
    '/_authenticated/app/feed/categories/': {
      id: '/_authenticated/app/feed/categories/'
      path: '/categories'
      fullPath: '/app/feed/categories'
      preLoaderRoute: typeof AuthenticatedAppFeedCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedAppFeedRoute
    }
    '/_authenticated/super-admin/organizations/$organizationId/edit': {
      id: '/_authenticated/super-admin/organizations/$organizationId/edit'
      path: '/super-admin/organizations/$organizationId/edit'
      fullPath: '/super-admin/organizations/$organizationId/edit'
      preLoaderRoute: typeof AuthenticatedSuperAdminOrganizationsOrganizationIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/$calendarId/events/new': {
      id: '/_authenticated/calendar/$calendarId/events/new'
      path: '/calendar/$calendarId/events/new'
      fullPath: '/calendar/$calendarId/events/new'
      preLoaderRoute: typeof AuthenticatedCalendarCalendarIdEventsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/$calendarId/events/$eventId': {
      id: '/_authenticated/calendar/$calendarId/events/$eventId'
      path: '/calendar/$calendarId/events/$eventId'
      fullPath: '/calendar/$calendarId/events/$eventId'
      preLoaderRoute: typeof AuthenticatedCalendarCalendarIdEventsEventIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/quick-access/sections/new': {
      id: '/_authenticated/app/quick-access/sections/new'
      path: '/sections/new'
      fullPath: '/app/quick-access/sections/new'
      preLoaderRoute: typeof AuthenticatedAppQuickAccessSectionsNewRouteImport
      parentRoute: typeof AuthenticatedAppQuickAccessRoute
    }
    '/_authenticated/app/quick-access/sections/$sectionId': {
      id: '/_authenticated/app/quick-access/sections/$sectionId'
      path: '/sections/$sectionId'
      fullPath: '/app/quick-access/sections/$sectionId'
      preLoaderRoute: typeof AuthenticatedAppQuickAccessSectionsSectionIdRouteImport
      parentRoute: typeof AuthenticatedAppQuickAccessRoute
    }
    '/_authenticated/app/feed/categories/new': {
      id: '/_authenticated/app/feed/categories/new'
      path: '/categories/new'
      fullPath: '/app/feed/categories/new'
      preLoaderRoute: typeof AuthenticatedAppFeedCategoriesNewRouteImport
      parentRoute: typeof AuthenticatedAppFeedRoute
    }
    '/_authenticated/app/feed/categories/$categoryId': {
      id: '/_authenticated/app/feed/categories/$categoryId'
      path: '/categories/$categoryId'
      fullPath: '/app/feed/categories/$categoryId'
      preLoaderRoute: typeof AuthenticatedAppFeedCategoriesCategoryIdRouteImport
      parentRoute: typeof AuthenticatedAppFeedRoute
    }
  }
}

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsConnectionsRoute: typeof AuthenticatedSettingsConnectionsRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsFacebookSuccessRoute: typeof AuthenticatedSettingsFacebookSuccessRoute
  AuthenticatedSettingsInfoRoute: typeof AuthenticatedSettingsInfoRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsOrganizationsRoute: typeof AuthenticatedSettingsOrganizationsRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsUsersRoute: typeof AuthenticatedSettingsUsersRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
  AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
  AuthenticatedSettingsConnectionsRoute: AuthenticatedSettingsConnectionsRoute,
  AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
  AuthenticatedSettingsFacebookSuccessRoute:
    AuthenticatedSettingsFacebookSuccessRoute,
  AuthenticatedSettingsInfoRoute: AuthenticatedSettingsInfoRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedSettingsOrganizationsRoute:
    AuthenticatedSettingsOrganizationsRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsUsersRoute: AuthenticatedSettingsUsersRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedAppFeedRouteChildren {
  AuthenticatedAppFeedIndexRoute: typeof AuthenticatedAppFeedIndexRoute
  AuthenticatedAppFeedCategoriesCategoryIdRoute: typeof AuthenticatedAppFeedCategoriesCategoryIdRoute
  AuthenticatedAppFeedCategoriesNewRoute: typeof AuthenticatedAppFeedCategoriesNewRoute
  AuthenticatedAppFeedCategoriesIndexRoute: typeof AuthenticatedAppFeedCategoriesIndexRoute
}

const AuthenticatedAppFeedRouteChildren: AuthenticatedAppFeedRouteChildren = {
  AuthenticatedAppFeedIndexRoute: AuthenticatedAppFeedIndexRoute,
  AuthenticatedAppFeedCategoriesCategoryIdRoute:
    AuthenticatedAppFeedCategoriesCategoryIdRoute,
  AuthenticatedAppFeedCategoriesNewRoute:
    AuthenticatedAppFeedCategoriesNewRoute,
  AuthenticatedAppFeedCategoriesIndexRoute:
    AuthenticatedAppFeedCategoriesIndexRoute,
}

const AuthenticatedAppFeedRouteWithChildren =
  AuthenticatedAppFeedRoute._addFileChildren(AuthenticatedAppFeedRouteChildren)

interface AuthenticatedAppQuickAccessRouteChildren {
  AuthenticatedAppQuickAccessNewRoute: typeof AuthenticatedAppQuickAccessNewRoute
  AuthenticatedAppQuickAccessIndexRoute: typeof AuthenticatedAppQuickAccessIndexRoute
  AuthenticatedAppQuickAccessSectionsSectionIdRoute: typeof AuthenticatedAppQuickAccessSectionsSectionIdRoute
  AuthenticatedAppQuickAccessSectionsNewRoute: typeof AuthenticatedAppQuickAccessSectionsNewRoute
  AuthenticatedAppQuickAccessSectionsIndexRoute: typeof AuthenticatedAppQuickAccessSectionsIndexRoute
}

const AuthenticatedAppQuickAccessRouteChildren: AuthenticatedAppQuickAccessRouteChildren =
  {
    AuthenticatedAppQuickAccessNewRoute: AuthenticatedAppQuickAccessNewRoute,
    AuthenticatedAppQuickAccessIndexRoute:
      AuthenticatedAppQuickAccessIndexRoute,
    AuthenticatedAppQuickAccessSectionsSectionIdRoute:
      AuthenticatedAppQuickAccessSectionsSectionIdRoute,
    AuthenticatedAppQuickAccessSectionsNewRoute:
      AuthenticatedAppQuickAccessSectionsNewRoute,
    AuthenticatedAppQuickAccessSectionsIndexRoute:
      AuthenticatedAppQuickAccessSectionsIndexRoute,
  }

const AuthenticatedAppQuickAccessRouteWithChildren =
  AuthenticatedAppQuickAccessRoute._addFileChildren(
    AuthenticatedAppQuickAccessRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAiRoute: typeof AuthenticatedAiRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedFeedRoute: typeof AuthenticatedFeedRoute
  AuthenticatedLibraryRoute: typeof AuthenticatedLibraryRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedStoriesRoute: typeof AuthenticatedStoriesRoute
  AuthenticatedAppFeedRoute: typeof AuthenticatedAppFeedRouteWithChildren
  AuthenticatedAppPinnedPostsRoute: typeof AuthenticatedAppPinnedPostsRoute
  AuthenticatedAppPostsRoute: typeof AuthenticatedAppPostsRoute
  AuthenticatedAppQuickAccessRoute: typeof AuthenticatedAppQuickAccessRouteWithChildren
  AuthenticatedAppStoriesRoute: typeof AuthenticatedAppStoriesRoute
  AuthenticatedConversationsConversationIdRoute: typeof AuthenticatedConversationsConversationIdRoute
  AuthenticatedConversationsNewRoute: typeof AuthenticatedConversationsNewRoute
  AuthenticatedIncidentsIncidentIdRoute: typeof AuthenticatedIncidentsIncidentIdRoute
  AuthenticatedLinksTranslationsRoute: typeof AuthenticatedLinksTranslationsRoute
  AuthenticatedMediaMediaIdRoute: typeof AuthenticatedMediaMediaIdRoute
  AuthenticatedMediaGridRoute: typeof AuthenticatedMediaGridRoute
  AuthenticatedMediaNewRoute: typeof AuthenticatedMediaNewRoute
  AuthenticatedMeetingsMeetingIdRoute: typeof AuthenticatedMeetingsMeetingIdRoute
  AuthenticatedMeetingsNewRoute: typeof AuthenticatedMeetingsNewRoute
  AuthenticatedNotificationsNewRoute: typeof AuthenticatedNotificationsNewRoute
  AuthenticatedPlacesPlaceIdRoute: typeof AuthenticatedPlacesPlaceIdRoute
  AuthenticatedPlacesNewRoute: typeof AuthenticatedPlacesNewRoute
  AuthenticatedPostsPostIdRoute: typeof AuthenticatedPostsPostIdRoute
  AuthenticatedPostsNewRoute: typeof AuthenticatedPostsNewRoute
  AuthenticatedPostsNewPageRoute: typeof AuthenticatedPostsNewPageRoute
  AuthenticatedPostsNewTipTapRoute: typeof AuthenticatedPostsNewTipTapRoute
  AuthenticatedPostsTipyTapRoute: typeof AuthenticatedPostsTipyTapRoute
  AuthenticatedProfilesNewRoute: typeof AuthenticatedProfilesNewRoute
  AuthenticatedResidentsIdRoute: typeof AuthenticatedResidentsIdRoute
  AuthenticatedResidentsMapRoute: typeof AuthenticatedResidentsMapRoute
  AuthenticatedResidentsNewRoute: typeof AuthenticatedResidentsNewRoute
  AuthenticatedSurveysNewRoute: typeof AuthenticatedSurveysNewRoute
  AuthenticatedWebLinksWebLinkIdRoute: typeof AuthenticatedWebLinksWebLinkIdRoute
  AuthenticatedWebLinksNewRoute: typeof AuthenticatedWebLinksNewRoute
  AuthenticatedAppIndexRoute: typeof AuthenticatedAppIndexRoute
  AuthenticatedCalendarIndexRoute: typeof AuthenticatedCalendarIndexRoute
  AuthenticatedCalendarsIndexRoute: typeof AuthenticatedCalendarsIndexRoute
  AuthenticatedConversationsIndexRoute: typeof AuthenticatedConversationsIndexRoute
  AuthenticatedHomeIndexRoute: typeof AuthenticatedHomeIndexRoute
  AuthenticatedIncidentsIndexRoute: typeof AuthenticatedIncidentsIndexRoute
  AuthenticatedMediaIndexRoute: typeof AuthenticatedMediaIndexRoute
  AuthenticatedMeetingsIndexRoute: typeof AuthenticatedMeetingsIndexRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedPlacesIndexRoute: typeof AuthenticatedPlacesIndexRoute
  AuthenticatedPostsIndexRoute: typeof AuthenticatedPostsIndexRoute
  AuthenticatedResidentsIndexRoute: typeof AuthenticatedResidentsIndexRoute
  AuthenticatedSuperAdminIndexRoute: typeof AuthenticatedSuperAdminIndexRoute
  AuthenticatedSurveysIndexRoute: typeof AuthenticatedSurveysIndexRoute
  AuthenticatedWebLinksIndexRoute: typeof AuthenticatedWebLinksIndexRoute
  AuthenticatedWebsiteIndexRoute: typeof AuthenticatedWebsiteIndexRoute
  AuthenticatedSuperAdminOrganizationsListRoute: typeof AuthenticatedSuperAdminOrganizationsListRoute
  AuthenticatedSuperAdminOrganizationsNewRoute: typeof AuthenticatedSuperAdminOrganizationsNewRoute
  AuthenticatedAppHomeIndexRoute: typeof AuthenticatedAppHomeIndexRoute
  AuthenticatedCalendarCalendarIdIndexRoute: typeof AuthenticatedCalendarCalendarIdIndexRoute
  AuthenticatedSuperAdminOrganizationsIndexRoute: typeof AuthenticatedSuperAdminOrganizationsIndexRoute
  AuthenticatedWebsiteDisclosuresIndexRoute: typeof AuthenticatedWebsiteDisclosuresIndexRoute
  AuthenticatedWebsiteDocumentsIndexRoute: typeof AuthenticatedWebsiteDocumentsIndexRoute
  AuthenticatedWebsiteDownloadsIndexRoute: typeof AuthenticatedWebsiteDownloadsIndexRoute
  AuthenticatedWebsiteEventsIndexRoute: typeof AuthenticatedWebsiteEventsIndexRoute
  AuthenticatedWebsiteGovernmentDocumentsIndexRoute: typeof AuthenticatedWebsiteGovernmentDocumentsIndexRoute
  AuthenticatedWebsiteJobsIndexRoute: typeof AuthenticatedWebsiteJobsIndexRoute
  AuthenticatedWebsiteNewsNoticesIndexRoute: typeof AuthenticatedWebsiteNewsNoticesIndexRoute
  AuthenticatedWebsiteNoticesIndexRoute: typeof AuthenticatedWebsiteNoticesIndexRoute
  AuthenticatedWebsiteStaffDirectoryIndexRoute: typeof AuthenticatedWebsiteStaffDirectoryIndexRoute
  AuthenticatedCalendarCalendarIdEventsEventIdRoute: typeof AuthenticatedCalendarCalendarIdEventsEventIdRoute
  AuthenticatedCalendarCalendarIdEventsNewRoute: typeof AuthenticatedCalendarCalendarIdEventsNewRoute
  AuthenticatedSuperAdminOrganizationsOrganizationIdEditRoute: typeof AuthenticatedSuperAdminOrganizationsOrganizationIdEditRoute
  AuthenticatedCalendarCalendarIdEventsIndexRoute: typeof AuthenticatedCalendarCalendarIdEventsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAiRoute: AuthenticatedAiRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedFeedRoute: AuthenticatedFeedRoute,
  AuthenticatedLibraryRoute: AuthenticatedLibraryRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedStoriesRoute: AuthenticatedStoriesRoute,
  AuthenticatedAppFeedRoute: AuthenticatedAppFeedRouteWithChildren,
  AuthenticatedAppPinnedPostsRoute: AuthenticatedAppPinnedPostsRoute,
  AuthenticatedAppPostsRoute: AuthenticatedAppPostsRoute,
  AuthenticatedAppQuickAccessRoute:
    AuthenticatedAppQuickAccessRouteWithChildren,
  AuthenticatedAppStoriesRoute: AuthenticatedAppStoriesRoute,
  AuthenticatedConversationsConversationIdRoute:
    AuthenticatedConversationsConversationIdRoute,
  AuthenticatedConversationsNewRoute: AuthenticatedConversationsNewRoute,
  AuthenticatedIncidentsIncidentIdRoute: AuthenticatedIncidentsIncidentIdRoute,
  AuthenticatedLinksTranslationsRoute: AuthenticatedLinksTranslationsRoute,
  AuthenticatedMediaMediaIdRoute: AuthenticatedMediaMediaIdRoute,
  AuthenticatedMediaGridRoute: AuthenticatedMediaGridRoute,
  AuthenticatedMediaNewRoute: AuthenticatedMediaNewRoute,
  AuthenticatedMeetingsMeetingIdRoute: AuthenticatedMeetingsMeetingIdRoute,
  AuthenticatedMeetingsNewRoute: AuthenticatedMeetingsNewRoute,
  AuthenticatedNotificationsNewRoute: AuthenticatedNotificationsNewRoute,
  AuthenticatedPlacesPlaceIdRoute: AuthenticatedPlacesPlaceIdRoute,
  AuthenticatedPlacesNewRoute: AuthenticatedPlacesNewRoute,
  AuthenticatedPostsPostIdRoute: AuthenticatedPostsPostIdRoute,
  AuthenticatedPostsNewRoute: AuthenticatedPostsNewRoute,
  AuthenticatedPostsNewPageRoute: AuthenticatedPostsNewPageRoute,
  AuthenticatedPostsNewTipTapRoute: AuthenticatedPostsNewTipTapRoute,
  AuthenticatedPostsTipyTapRoute: AuthenticatedPostsTipyTapRoute,
  AuthenticatedProfilesNewRoute: AuthenticatedProfilesNewRoute,
  AuthenticatedResidentsIdRoute: AuthenticatedResidentsIdRoute,
  AuthenticatedResidentsMapRoute: AuthenticatedResidentsMapRoute,
  AuthenticatedResidentsNewRoute: AuthenticatedResidentsNewRoute,
  AuthenticatedSurveysNewRoute: AuthenticatedSurveysNewRoute,
  AuthenticatedWebLinksWebLinkIdRoute: AuthenticatedWebLinksWebLinkIdRoute,
  AuthenticatedWebLinksNewRoute: AuthenticatedWebLinksNewRoute,
  AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute,
  AuthenticatedCalendarIndexRoute: AuthenticatedCalendarIndexRoute,
  AuthenticatedCalendarsIndexRoute: AuthenticatedCalendarsIndexRoute,
  AuthenticatedConversationsIndexRoute: AuthenticatedConversationsIndexRoute,
  AuthenticatedHomeIndexRoute: AuthenticatedHomeIndexRoute,
  AuthenticatedIncidentsIndexRoute: AuthenticatedIncidentsIndexRoute,
  AuthenticatedMediaIndexRoute: AuthenticatedMediaIndexRoute,
  AuthenticatedMeetingsIndexRoute: AuthenticatedMeetingsIndexRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedPlacesIndexRoute: AuthenticatedPlacesIndexRoute,
  AuthenticatedPostsIndexRoute: AuthenticatedPostsIndexRoute,
  AuthenticatedResidentsIndexRoute: AuthenticatedResidentsIndexRoute,
  AuthenticatedSuperAdminIndexRoute: AuthenticatedSuperAdminIndexRoute,
  AuthenticatedSurveysIndexRoute: AuthenticatedSurveysIndexRoute,
  AuthenticatedWebLinksIndexRoute: AuthenticatedWebLinksIndexRoute,
  AuthenticatedWebsiteIndexRoute: AuthenticatedWebsiteIndexRoute,
  AuthenticatedSuperAdminOrganizationsListRoute:
    AuthenticatedSuperAdminOrganizationsListRoute,
  AuthenticatedSuperAdminOrganizationsNewRoute:
    AuthenticatedSuperAdminOrganizationsNewRoute,
  AuthenticatedAppHomeIndexRoute: AuthenticatedAppHomeIndexRoute,
  AuthenticatedCalendarCalendarIdIndexRoute:
    AuthenticatedCalendarCalendarIdIndexRoute,
  AuthenticatedSuperAdminOrganizationsIndexRoute:
    AuthenticatedSuperAdminOrganizationsIndexRoute,
  AuthenticatedWebsiteDisclosuresIndexRoute:
    AuthenticatedWebsiteDisclosuresIndexRoute,
  AuthenticatedWebsiteDocumentsIndexRoute:
    AuthenticatedWebsiteDocumentsIndexRoute,
  AuthenticatedWebsiteDownloadsIndexRoute:
    AuthenticatedWebsiteDownloadsIndexRoute,
  AuthenticatedWebsiteEventsIndexRoute: AuthenticatedWebsiteEventsIndexRoute,
  AuthenticatedWebsiteGovernmentDocumentsIndexRoute:
    AuthenticatedWebsiteGovernmentDocumentsIndexRoute,
  AuthenticatedWebsiteJobsIndexRoute: AuthenticatedWebsiteJobsIndexRoute,
  AuthenticatedWebsiteNewsNoticesIndexRoute:
    AuthenticatedWebsiteNewsNoticesIndexRoute,
  AuthenticatedWebsiteNoticesIndexRoute: AuthenticatedWebsiteNoticesIndexRoute,
  AuthenticatedWebsiteStaffDirectoryIndexRoute:
    AuthenticatedWebsiteStaffDirectoryIndexRoute,
  AuthenticatedCalendarCalendarIdEventsEventIdRoute:
    AuthenticatedCalendarCalendarIdEventsEventIdRoute,
  AuthenticatedCalendarCalendarIdEventsNewRoute:
    AuthenticatedCalendarCalendarIdEventsNewRoute,
  AuthenticatedSuperAdminOrganizationsOrganizationIdEditRoute:
    AuthenticatedSuperAdminOrganizationsOrganizationIdEditRoute,
  AuthenticatedCalendarCalendarIdEventsIndexRoute:
    AuthenticatedCalendarCalendarIdEventsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicResetSuccessRoute: typeof PublicResetSuccessRoute
  PublicPPostIdRoute: typeof PublicPPostIdRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicResetSuccessRoute: PublicResetSuccessRoute,
  PublicPPostIdRoute: PublicPPostIdRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LayoutRoute: LayoutRoute,
  PublicRoute: PublicRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
